const dateFormat = 'DD/MM/YYYY';
const ddmmmmyyyy = 'DD MMMM YYYY';
const yyyymmddhhmmss = 'YYYY-MM-DD hh:mm:ss';
const XlsType = 'application/vnd.ms-excel';
const XlsWpsType = 'application/wps-office.xls';
const XlsxType =
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
const CsvType = 'text/csv';
const JsType = 'text/javascript';
const pythonDjangoType = 'text/x-python';
const DmnType = 'dmn';
const success = 'success';
const info = 'info';
const warning = 'warning';
const error = 'error';

const constants = {
  dateFormat,
  ddmmmmyyyy,
  yyyymmddhhmmss,
  XlsType,
  XlsWpsType,
  XlsxType,
  CsvType,
  JsType,
  pythonDjangoType,
  DmnType,
  success,
  info,
  warning,
  error,
};

export default constants;
